import { RouteLinkProps } from "../types/global";
import {
  URL_METHODIST_MAIN,
  URL_METHODIST_REPORTS,
  URL_AUTH_JSHIR_REGISTER,
  URL_AUTH_LOGIN,
  URL_AUTH_REGISTER,
  URL_AUTH_RESET_PASSWORD,
  URL_TEACHER_CHECK_MYSELF,
  URL_TEACHER_MAIN,
  URL_TEACHER_REPORTS,
  URL_METHODIST_MAIN_VIEW,
  URL_METHODIST_MAIN_EVALUATION,
  URL_METHODIST_REPORTS_VIEW,
  URL_TEACHER_MAIN_VIEW,
  URL_TEACHER_MAIN_NEW,
  URL_TEACHER_REPORTS_VIEW,
  URL_TEACHER_REPORTS_NEW,
  PROFILE,
} from "./page_urls";
import pages from "../pages";

export const methodistPages: RouteLinkProps[] = [
  {
    component: pages.methodist.Dashboard,
    path: URL_METHODIST_MAIN,
  },
  {
    component: pages.methodist.DashboardView,
    path: URL_METHODIST_MAIN_VIEW,
  },
  {
    component: pages.methodist.DVEvaluation,
    path: URL_METHODIST_MAIN_EVALUATION,
  },
  {
    component: pages.methodist.Reports,
    path: URL_METHODIST_REPORTS,
  },
  {
    component: pages.methodist.ReportsView,
    path: URL_METHODIST_REPORTS_VIEW,
  },
  {
    component: pages.toAll.Cabinet,
    path: PROFILE,
  },
];

export const teacherPages: RouteLinkProps[] = [
  {
    component: pages.teacher.Dashboard,
    path: URL_TEACHER_MAIN,
  },
  {
    component: pages.teacher.DashboardView,
    path: URL_TEACHER_MAIN_VIEW,
  },
  {
    component: pages.teacher.DashboardNew,
    path: URL_TEACHER_MAIN_NEW,
  },
  {
    component: pages.teacher.CheckMyself,
    path: URL_TEACHER_CHECK_MYSELF,
  },
  {
    component: pages.teacher.Reports,
    path: URL_TEACHER_REPORTS,
  },
  {
    component: pages.teacher.ReportsView,
    path: URL_TEACHER_REPORTS_VIEW,
  },
  {
    component: pages.teacher.ReportsNew,
    path: URL_TEACHER_REPORTS_NEW,
  },
  {
    component: pages.toAll.Cabinet,
    path: PROFILE,
  },
];

export const authPages: RouteLinkProps[] = [
  {
    component: pages.auth.Login,
    path: URL_AUTH_LOGIN,
  },
  {
    component: pages.auth.RestorePassword,
    path: URL_AUTH_RESET_PASSWORD,
  },
  {
    component: pages.auth.Registration,
    path: URL_AUTH_REGISTER,
  },
  {
    component: pages.auth.RegistrationJSHIR,
    path: URL_AUTH_JSHIR_REGISTER,
  },
];
